import React from 'react';
import { Route, Switch } from 'react-router-dom';
import { RouteKeys } from './route-keys';
import ListView from './ListView';
import CreateView from './CreateView';
import EditView from './EditView';

const RoleRouter: React.FunctionComponent = () => {
  return (
    <Switch>
      <Route path={RouteKeys.New} component={CreateView} />
      <Route path={RouteKeys.Edit} component={EditView} />
      <Route path={RouteKeys.List} component={ListView} />
    </Switch>
  );
};

export default RoleRouter;
